import { createContext } from 'react';
import type { I18nContextValue } from '../types/i18nContext';

export const I18nContext = createContext<I18nContextValue | null>(null);
